<template>
  <div class="page_chili" style="height:1000px">
    <el-row style="text-align: right">
      <el-col>
        <el-radio v-model="radioPage3" label="1" @change="GetData"
          >实时</el-radio
        >
        <el-radio v-model="radioPage3" label="2" @change="GetData">天</el-radio>
        <el-radio v-model="radioPage3" label="3" @change="GetData">月</el-radio>
        <el-radio v-model="radioPage3" label="4" @change="GetData">年</el-radio>
        <el-date-picker
          v-model="DatePage3"
          type="date"
          placeholder="选择日期"
          @change="GetData"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" class="span3Css">
        <el-radio-group
          v-model="test"
          @change="GetData()"
          size="mini"
          text-color="red"
          fill="#EEEEEE"
          style="padding: 10, 5, 10, 5"
        >
          <el-radio-button
            style="display: block"
            v-for="(item, i) in items"
            :label="item.content"
            :key="i"
            :disabled="item.disabled"
            :checked="item.checked"
          >
            <div style class="Transbox">
              <img
                src="../../Imag/ja.png"
                style="width: 120px; height: 100px; border: 1px"
              />
              <br />
              <span>{{ item.id }}</span>
            </div>
          </el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="15" style="height: 100%; padding: 20px">
        <div style="width: 100%; height: 100%">
          <div style="width: 100%">
            <span class="h4title">三相电压曲线</span>
          </div>
          <div class="tableTitle">
            <span class="midText"></span>
          </div>
          <div style="width: 100%">
            <div id="Page5_1" style="width: 900px; height: 600px"></div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" class="centDiv">
        <el-row>
          <br />
          <span class="h4title">三相不平衡率</span>

          <br />
          <div class="tableTitle">
            <span class="midText"></span>
          </div>
          <div
            id="Page5_2"
            style="width: 400px; height: 300px; padding: 0px"
          ></div>
        </el-row>
        <el-row>
          <span>平均三相不平衡率:{{ Irate }}%</span>
          <br />
          <span>不平衡率限值:{{ limit }}%</span>
          <br />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
import request from "../../utils/request";
export default {
  data() {
    return {
      msg: "",
      sites: [{ name: "Runoob" }, { name: "Google" }, { name: "Taobao" }],
      radioPage3: "1",
      DatePage3: new Date(),
      DataValuePage3: [],
      titlePage: "",
      test: '1',
      Irate: "",
      limit: "",
      items: [
        { id: "一期1#变", content: "1", disabled: false, checked: true },
        { id: "一期2#变", content: "2", disabled: false, checked: false },
        { id: "三期1#变", content: "4", disabled: false, checked: false },
        { id: "二期1#变", content: "5", disabled: false, checked: false },
        { id: "二期2#变", content: "6", disabled: false, checked: false },
        { id: "金桥35kv主变", content: "7", disabled: false, checked: false },
        { id: "金桥10KV备用变", content: "8", disabled: false, checked: false },
      ],
    };
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      var sizeForm = {
        TimeTypePage3: parseInt(this.radioPage3),
        DateTimePage3: this.DatePage3,
        TransformerID: this.test,
      };
      request({
        url: "MeterTrans/GetPage5Data",
        method: "post",
        data: sizeForm,
      }).then((response) => {
        var that = this;
        // that.anchor = response.data.rust;
        // that.data = response.data.rust2[1];
        this.drawLine(response);
      });
    },
    drawLine(va) {
      // 基于准备好的dom，初始化echarts实例
      var chart1 = echarts.init(document.getElementById("Page5_1"));
      var data = "";
      var data1 = "";
      var data2 = "";
      var data3 = "";
      var data4 = "";
      var data23 = "";
      var data24 = "";
      if (va.data.code == "1") {
        var data = va.data.ia;
        var data1 = va.data.ib;
        var data2 = va.data.ic;
        var data3 = va.data.ip;
        var data4 = va.data.im;
        var anchor = va.data.startEndTime;
        this.limit = va.data.limit;
        this.Irate = va.data.Irate;
        var pveLoad = va.data.Irate;
      }
      if (va.data.code == "2") {
        data24 = va.data.KArr;
        var anchor = va.data.Date;
        this.Irate = va.data.Ru3.value;
        this.limit = va.data.Tvalue;
        var pveLoad = va.data.Ru3.value;
      }

      var optionPage4_1 = {
        title: {
          text: "",
        },
        textStyle: {
          color: "#fff",
          fontStyle: "normal",
          fontFamily: "微软雅黑",
          fontSize: 12,
        },
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            //格式化数据的函数
            return (
              "A相电压:" +
              params[0].value[1] +
              "<br/>B相电压:" +
              params[1].value[1] +
              "<br/>C相电压:" +
              params[2].value[1] +
              "<br/>三相不平衡率:" +
              params[3].value[1] +
              "<br/>三相不平衡率限值:" +
              params[4].value[1]
            );
          },
        },
        color: ["#2878CC", "#1ACE93", "#0D4885", "#5B9FE6", "#4034D3"],
        grid: {
          x: 25,
          y: 25,
          x2: 15,
          y2: 20,
          top: "100px",
          bottom: "15px",
          borderWidth: 1,
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        grid: {
          x: 50,
          y: 50,
          x2: 50,
          y2: 100,
          top: "100px",
          bottom: "15px",
          borderWidth: 1,
          containLabel: true,
        },
        legend: {
          padding: [50, 0, 20, 0],
          data: ["A相电压", "B相电压", "C相电压", "不平衡率", "不平衡率限值"],
          textStyle: {
            color: "rgba(91, 127, 234, 1)",
          },
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            }, //区域缩放，区域缩放还原
            dataView: {
              readOnly: false,
            }, //数据视图
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
            restore: {}, //还原
            saveAsImage: {}, //保存为图片
          },
        },
        xAxis: {
          type: "time",
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        yAxis: [
          {
            name: "不平衡率%",
            type: "value",
            boundaryGap: [0, "100%"],
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#0087ED",
                width: 1, //这里是为了突出显示加上的
              },
            },
          },
          {
            name: "单位:(V)",
            type: "value",
            boundaryGap: [0, "100%"],
            axisLine: {
              lineStyle: {
                color: "#0087ED",
                width: 1, //这里是为了突出显示加上的
              },
            },
            min: 150,
            splitLine: {
              show: false,
            },
             scale:true,//自适应Y轴
          },
        ],
        series: [
          {
            name: "A相电压",
            type: "line",
            showSymbol: false,
            hoverAnimation: false,
            yAxisIndex: 1,
            data: data,
            symbol: "none", //不显示圆点
          },
          {
            name: "B相电压",
            type: "line",
            data: data1,
            yAxisIndex: 1,
            symbol: "none", //不显示圆点
          },
          {
            name: "C相电压",
            type: "line",
            data: data2,
            yAxisIndex: 1,
            symbol: "none", //不显示圆点
          },
          {
            name: "不平衡率",
            type: "line",
            data: data3,
            symbol: "none", //不显示圆点
          },
          {
            name: "不平衡率限值",
            type: "line",
            data: data4,
            symbol: "none", //不显示圆点
          },
          {
            name: ".anchor",
            type: "line",
            showSymbol: false,
            data: this.anchor,
            itemStyle: { normal: { opacity: 0 } },
            lineStyle: { normal: { opacity: 0 } },
          },
        ],
      };
      var Page5_Day_Option = {
        title: {
          text: "",
          subtext: "",
          sublink: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (params) => {
            //格式化数据的函数
            return (
              "电压不平衡率:" +
              params[0].name +
              "<br/>最小值:" +
              params[0].data[1] +
              "<br/>最大值:" +
              params[0].data[2]
            );
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
          data: anchor,
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
          axisLine: {
            lineStyle: {
              color: "#0087ED",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            text: "三相电流不平衡率",
            type: "k",
            data: data24,
             itemStyle: {
              //图形样式
              normal: { color: "#61a0a8" },
              lineStyle: {
              width: 2,
              color: '#61a0a8', // 阳线边框颜色
              color0: '#61a0a8' // 阴线边框颜色
              },


            },
          },
        ],
      };
      if (va.data.code == 1) {
        chart1.setOption(optionPage4_1);
      } else {
        chart1.clear();
        chart1.setOption(Page5_Day_Option);
      }
      var chart32 = echarts.init(document.getElementById("Page5_2"));
      var optionPage3 = {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        grid: {
          x: 25,
          y: 45,
          x2: 5,
          y2: 20,
          borderWidth: 1,
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "业务指标",
            type: "gauge",
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0,
            detail: { formatter: "{value}%" },
            data: [pveLoad],
          },
        ],
      };
      chart32.setOption(optionPage3, true);
    },
  },
};
</script>
<style>
@import "./page.css";
</style>